import Vue from 'vue'
import Router from 'vue-router'

/* 首页导航栏 */
// region
const Index = resolve => require(['views/home/index'], resolve);
/* 首页 */
const home = resolve => require(['views/home/home'], resolve);
/* 我要安装 */
const install = resolve => require(['views/home/install'], resolve);
/* 我要维修 */
const repair = resolve => require(['views/repair/index'], resolve);
/* 找技师 */
const vertify = resolve => require(['views/vertify/index'], resolve);
/* 找安防公司 */
const company = resolve => require(['views/company/index'], resolve);
const completeinfo = resolve => require(['views/login/completeinfo'], resolve);
/* 行业动态 */
const white = resolve => require(['views/home/white'], resolve);
/* 个人中心（我的易安防）- 完善资料 */
const personal = resolve => require(['views/personal/index'], resolve);
// endregion

/* 个人中心导航栏 */
// region
const personal_index = resolve => require(['views/personal/me'], resolve);
/* 我的资料 */
const personal_data = resolve => require(['views/personal/data'], resolve);
/* 我的通知 */
const personal_message = resolve => require(['views/personal/message'], resolve);
/* 我的企业 */
const personal_company = resolve => require(['views/personal/company'], resolve);
/* 我的安防公司 */
const personal_security = resolve => require(['views/personal/security'], resolve);
/* 我的技师认证 */
const personal_worker = resolve => require(['views/personal/worker/verify'], resolve);
/* 我的订单 */
const personal_order = resolve => require(['views/order/index'], resolve);
/* 我的安防公司详情 */
const personal_secInsert = resolve => require(['views/personal/secInsert'], resolve);
/* 我的企业详情 */
const personal_comInsert = resolve => require(['views/personal/comInsert'], resolve);
// endregion

/* 技师详情 */
const vertifyDetail = resolve => require(['views/vertify/detail'], resolve);
const contact = resolve => require(['views/vertify/contact'], resolve);
const companyDetail = resolve => require(['views/company/detail'], resolve);
const companyContact = resolve => require(['views/company/contact'], resolve);
const suc = resolve => require(['views/personal/suc'], resolve);
const login = resolve => require(['views/login/index'], resolve);
const sign = resolve => require(['views/login/signup'], resolve);
const repairDetail = resolve => require(['views/order/repair/details'], resolve);
const installList = resolve => require(['views/order/install/index'], resolve);
const installDetail = resolve => require(['views/order/install/details'], resolve);
const designDetail = resolve => require(['views/order/design/details'], resolve);
const priceDetail = resolve => require(['views/order/price/details'], resolve);

// 下载app
const loadApp = resolve => require(['views/loadapp/index'], resolve);
Vue.use(Router)
export default new Router({
// 后端支持可开
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/index',
    },
    {
      path: '/',
      name: '首页导航',
      component: Index,
      children: [
        {
          path: 'index',
          name: '首页',
          component: home
        },
        {
          path: '/completeinfo',
          name: '注册成功',
          component: completeinfo
        },
        {
          path: 'install',
          name: '我要安装',
          component: install
        },
        {
          path: 'repair',
          name: '我要维修',
          component: repair
        },
        {
          path: 'vertify',
          name: '找技师',
          component: vertify
        },
        {
          path: 'company',
          name: '找安防公司',
          component: company
        },
        {
          path: 'dynamics',
          name: '行业动态',
          component: white
        },
        {
          path: 'security',
          name: '安防圈',
          component: white
        },
        {
          path: 'personal',
          name: '完善资料',
          component: personal
        },
        {
          path: 'personal',
          name: '个人中心',
          component: personal_index,
          children: [
            {
              path: 'data',
              name: '我的资料',
              component: personal_data
            },
            {
              path: 'message',
              name: '我的通知',
              component: personal_message
            },
            {
              path: 'company',
              name: '我的企业',
              component: personal_company
            },
            {
              path: 'security',
              name: '我的安防公司',
              component: personal_security
            },
            {
              path: 'worker',
              name: '我的技师认证',
              component: personal_worker
            },
            {
              path: 'order',
              name: '我的订单',
              component: personal_order
            }, {
              path: 'secinsert',
              name: '我的安防公司详情',
              component: personal_secInsert
            }, {
              path: 'cominsert',
              name: '我的企业详情',
              component: personal_comInsert
            },
            {
              path: '/repairDetail',
              name: '报修详情',
              component: repairDetail
            },
            {
              path: '/installDetail',
              name: '报装详情',
              component: installDetail
            },
            {
              path: '/designDetail',
              name: '设计详情',
              component: designDetail
            },
            {
              path: '/priceDetail',
              name: '报价详情',
              component: priceDetail
            },
          ]
        }
      ]
    },
    {
      path: '/vertifyDetail',
      name: '技师详情',
      component: vertifyDetail
    },
    {
      path: '/contact',
      name: '联系技师',
      component: contact
    },
    {
      path: '/companyDetail',
      name: '公司详情',
      component: companyDetail
    },
    {
      path: '/companyContact',
      name: '联系公司',
      component: companyContact
    },
    {
      path: '/suc',
      name: '成功',
      component: suc
    },
    {
      path: '/login',
      name: '登录',
      component: login
    },
   
    {
      path: '/sign',
      name: '注册',
      component: sign
    },
    {
      path: '/installList/:id',
      name: '报装列表',
      component: installList
    },
    {
      path: '/loadApp',
      name: '下载app',
      component: loadApp
    },

    {
      path: "*",
      redirect: "/index"
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js